import { createContext, useContext } from 'react';

const DOMAIN_MAP = {
  'motsrusse.fr':           'fr',
  'www.motsrusse.fr':       'fr',
  'myrussianwords.com':     'en',
  'www.myrussianwords.com': 'en',
  'meinrussisch.de':        'de',
  'www.meinrussisch.de':    'de',
  'palabrasrusas.es':       'es',
  'www.palabrasrusas.es':   'es',
  'parolerusse.it':         'it',
  'www.parolerusse.it':     'it',
  'localhost:3000':         'fr',
  'localhost:3001':         'en',
  'localhost:3002':         'de',
  'localhost:3003':         'es',
  'localhost:3004':         'it',
};

export const LANGS = {
  fr: {
    apiLang: 'fr',
    wordField: 'francais',
    exampleRuField: 'example_ru_fr',
    exampleLangField: 'example_fr',
    audioEx: 'ex_fr',
    noneLabel: 'Aucune de ces réponses',
    ui: {
      frequencyLabels: ['500 mots', '1 000 mots', '2 000 mots', '4 000 mots', '6 000 mots'],
      titlePrefix: 'Apprenez les',
      titleSuffix: 'les plus fréquents en russe',
      home: 'Accueil',
      wordList: 'Dictionnaire',
      cursiveToggle: 'Afficher le russe en cursive / en imprimerie',
      progressSaved: 'Sauvegarder ma progression',
      couverture: (v) => `${String(v).replace('.', ',')} % des mots d'un texte russe`,
      cancel: 'annuler',
      feedback: 'Retours / suggestions :',
      supportLine: 'Un retour, une critique ou du soutien :',
      supportCard: 'Carte / Apple Pay',
      soundOn: 'Désactiver le son',
      soundOff: 'Activer le son',
      listen: 'Écouter',
      listenAgain: 'Réécouter',
      pause: 'Pause',
      resume: 'Reprendre',
      loading: 'Chargement…',
      errorPrefix: 'Erreur :',
      retry: 'Réessayer',
      noWords: 'Aucun mot disponible.',
      bonusQuestion: 'Quelle phrase avez-vous entendue ?',
      bonus: {
        cloze:   'Complétez la phrase',
        match:   'Reliez chaque mot à sa traduction',
        anagram: "Remettez les lettres dans l'ordre",
        reverse: 'Quel mot russe correspond ?',
        listen:  "Qu'avez-vous entendu ?",
      },
      backToRussian: '← appuyer pour revoir le russe',
      seeTranslation: 'appuyer pour voir la traduction →',
      next: 'suivant →',
      paused: 'En pause : appuyer sur ▶ pour continuer',
      tapForExample: "appuyer pour voir une phrase d'exemple",
      tapToSeeWord: 'appuyer pour revoir le mot',
      toReview: (n) => `À revoir (${n})`,
      reviewTooltip: "Les mots ratés reviennent dans les prochaines sessions jusqu'à ce que vous les réussissiez deux fois de suite. ● = à revoir · ✓ = maîtrisé",
      reviewLegend: '● à revoir · ✓ acquis',
      session: {
        doneTitle: 'Séance terminée',
        rescued: "sauvés de l'oubli",
        continueBtn: 'Continuer',
        correct: 'réussis',
        seen: 'mots vus',
        days: (n) => (n > 1 ? 'jours' : 'jour'),
      },
      texte: {
        listen: 'Écouter le texte',
        optOutPrompt: 'Vous passez ces textes à chaque fois. On arrête de les afficher ?',
        optOutYes: 'Ne plus les afficher',
        optOutNo: 'Continuer à les voir',
        eyebrow: 'Bonus',
        skip: 'Passer',
        next: 'Voir le bilan',
        formats: { texto: 'Message', enigme: 'Devinette', fait: 'Le savais-tu',
                   annonce: 'Petite annonce', journal: 'Journal', conte: 'Conte',
                   dialogue: 'Dialogue' },
      },
      levelTest: {
        introTitle: 'Test de niveau de russe',
        timeCap: 'Temps restant pour répondre',
        progressLbl: 'Progression du test',
        loadError: 'impossible de charger les mots.',
        chooseTranslation: 'Choisissez la traduction',
        chooseWord: 'Choisissez le mot russe',
        fillBlank: 'Complétez la phrase',
        listenPick: 'Écoutez et choisissez la traduction',
        listenSpell: 'Écoutez et choisissez l\u2019orthographe',
        readCursive: 'Écriture manuscrite : que signifie ce mot ?',
        range: (a, b) => `estimation entre ${a} et ${b} mots`,
        resultTitle: 'Votre niveau estimé',
        cefrName: { A1: 'Débutant', A2: 'Élémentaire', B1: 'Intermédiaire', B2: 'Intermédiaire supérieur', C1: 'Avancé' },
        wordsScale: 'des 6000 mots les plus fréquents',
        disclaimer: 'Estimation indicative fondée sur le vocabulaire de fréquence. Ce n’est pas un examen officiel.',
        ctaTrain: 'M’entraîner à ce niveau',
        share: 'Partager mon résultat',
        shared: '✓ Copié',
        shareText: (cefr, words) => `Mon niveau de russe : ${cefr} (≈ ${words} mots). Et toi ?`,
        ctaRetake: 'Refaire le test',
        linkLabel: 'Test de niveau',
        pagePath: '/mot/fr/test-de-niveau.html',
      },
      fullQuiz: 'Quiz complet',
      replique: 'Choisissez la réponse la plus naturelle',
      srs: {
        due: 'à revoir',
        soon: 'bientôt',
        solid: 'acquis',
      },
      about: 'À propos',
      aboutUrl: '/mot/fr/a-propos.html',
      noneCorrectLabel: (word) => `Aucune (réponse : ${word})`,
      account: {
        mots: {
          title: 'Vos mots',
          tabs: { a_revoir: 'À revoir', erreurs: 'En erreur', appris: 'Appris' },
          hints: {
            a_revoir: 'Leur date de révision est passée. Ce sont eux qui partent en premier.',
            erreurs: 'Ratés à la dernière rencontre. Ils reviennent dès demain.',
            appris: 'Répondus juste cinq fois de suite. Ils tiennent tout seuls.',
          },
          empty: {
            a_revoir: 'Rien à revoir aujourd\u2019hui.',
            erreurs: 'Aucun mot en erreur. Rien à rattraper.',
            appris: 'Encore aucun mot appris. Il en faut cinq rappels réussis.',
          },
          quiz: (n) => `Réviser ${n} mot${n > 1 ? 's' : ''}`,
          tropPeu: (n) => `Il faut au moins ${n} mots pour lancer une série.`,
          more: (n) => `et ${n} de plus`,
          intro: 'Vos mots, rangés selon ce que la mémoire en dit.',
        },
        textesOff: 'Les textes de fin de série sont masqués.',
        textesOn: 'Les réafficher',
        title: 'Votre progression',
        intro: 'Retrouvez votre progression sur tous vos appareils et tous les sites.',
        tabCreate: 'Créer un compte',
        tabLogin: 'Se connecter',
        handle: 'Identifiant',
        handlePlaceholder: 'un identifiant',
        passphrase: 'Phrase secrète',
        passphrasePlaceholder: 'votre phrase secrète',
        passphraseHint: 'Au moins 8 caractères. Notez-la bien : sans email, elle ne peut pas être réinitialisée.',
        createBtn: 'Créer le compte',
        loginBtn: 'Se connecter',
        logoutBtn: 'Se déconnecter',
        loggedInAs: (h) => `compte : ${h}`,
        deleteAccount: 'Supprimer le compte',
        deleteConfirm: 'Confirmer la suppression',
        // Invitation du bilan, au moment où un point tombe : jamais avant, jamais
        // pendant le quiz. On parle de portabilité, pas d'inscription.
        inviteLine: 'Votre progression ne vit que dans ce navigateur.',
        inviteCta: 'La garder ailleurs',
        mergePrompt: 'Une progression non liée existe sur cet appareil. La fusionner avec ce compte ?',
        mergeYes: 'Fusionner',
        mergeNo: 'Ignorer',
        close: 'Fermer',
        errors: {
          handle_invalid: 'Identifiant invalide (3 à 32 caractères : lettres, chiffres, . _ -).',
          passphrase_weak: 'Phrase secrète trop faible (au moins 8 caractères).',
          handle_taken: 'Cet identifiant est déjà pris.',
          already_claimed: 'Cet appareil a déjà un compte.',
          invalid_credentials: 'Identifiant ou phrase secrète incorrect.',
          rate_limited: 'Trop de tentatives. Réessayez dans quelques minutes.',
          generic: 'Une erreur est survenue. Réessayez.',
        },
      },
    },
  },

  en: {
    apiLang: 'en',
    wordField: 'english',
    exampleRuField: 'example_ru_en',
    exampleLangField: 'example_en',
    audioEx: 'ex_en',
    noneLabel: 'None of those answers',
    ui: {
      frequencyLabels: ['500 words', '1,000 words', '2,000 words', '4,000 words', '6,000 words'],
      titlePrefix: 'Learn the',
      titleSuffix: 'most frequent Russian words',
      home: 'Home',
      wordList: 'Dictionary',
      cursiveToggle: 'Show Russian in cursive / print letters',
      progressSaved: 'Save my progress',
      couverture: (v) => `${v}% of the words in a Russian text`,
      cancel: 'cancel',
      feedback: 'Feedback / suggestions:',
      supportLine: 'Feedback, criticism or support:',
      supportCard: 'Card / Apple Pay',
      soundOn: 'Disable sound',
      soundOff: 'Enable sound',
      listen: 'Listen',
      listenAgain: 'Listen again',
      pause: 'Pause',
      resume: 'Resume',
      loading: 'Loading…',
      errorPrefix: 'Error:',
      retry: 'Retry',
      noWords: 'No words available.',
      bonusQuestion: 'Which sentence did you hear?',
      bonus: {
        cloze:   'Fill in the blank',
        match:   'Match each word to its translation',
        anagram: 'Put the letters in order',
        reverse: 'Which Russian word matches?',
        listen:  'What did you hear?',
      },
      backToRussian: '← tap to see Russian',
      seeTranslation: 'tap to see translation →',
      next: 'next →',
      paused: 'Paused : press ▶ to continue',
      tapForExample: 'tap for an example sentence',
      tapToSeeWord: 'tap to see the word again',
      toReview: (n) => `To review (${n})`,
      reviewTooltip: 'Words you missed come back in future sessions until you get them right twice in a row. ● = to redo · ✓ = mastered',
      reviewLegend: '● to redo · ✓ mastered',
      session: {
        doneTitle: 'Session complete',
        rescued: 'saved from forgetting',
        continueBtn: 'Continue',
        correct: 'correct',
        seen: 'words seen',
        days: (n) => (n > 1 ? 'days' : 'day'),
      },
      texte: {
        listen: 'Listen to the text',
        optOutPrompt: 'You skip these texts every time. Should we stop showing them?',
        optOutYes: 'Stop showing them',
        optOutNo: 'Keep showing them',
        eyebrow: 'Bonus',
        skip: 'Skip',
        next: 'See summary',
        formats: { texto: 'Text message', enigme: 'Riddle', fait: 'Did you know',
                   annonce: 'Classified ad', journal: 'Diary', conte: 'Tale',
                   dialogue: 'Dialogue' },
      },
      levelTest: {
        introTitle: 'Russian level test',
        timeCap: 'Time left to answer',
        progressLbl: 'Test progress',
        loadError: 'could not load words.',
        chooseTranslation: 'Choose the translation',
        chooseWord: 'Choose the Russian word',
        fillBlank: 'Fill in the sentence',
        listenPick: 'Listen and choose the translation',
        listenSpell: 'Listen and choose the spelling',
        readCursive: 'Handwriting: what does this word mean?',
        range: (a, b) => `estimated between ${a} and ${b} words`,
        resultTitle: 'Your estimated level',
        cefrName: { A1: 'Beginner', A2: 'Elementary', B1: 'Intermediate', B2: 'Upper-intermediate', C1: 'Advanced' },
        wordsScale: 'of the 6,000 most frequent words',
        disclaimer: 'Indicative estimate based on frequency vocabulary. Not an official exam.',
        ctaTrain: 'Practise at this level',
        share: 'Share my result',
        shared: '✓ Copied',
        shareText: (cefr, words) => `My Russian level: ${cefr} (≈ ${words} words). What's yours?`,
        ctaRetake: 'Retake the test',
        linkLabel: 'Level test',
        pagePath: '/mot/en/russian-level-test.html',
      },
      fullQuiz: 'Full quiz',
      replique: 'Choose the most natural reply',
      srs: {
        due: 'to review',
        soon: 'soon',
        solid: 'solid',
      },
      about: 'About',
      aboutUrl: '/mot/en/about.html',
      noneCorrectLabel: (word) => `None (answer: ${word})`,
      account: {
        mots: {
          title: 'Your words',
          tabs: { a_revoir: 'To review', erreurs: 'Got wrong', appris: 'Learned' },
          hints: {
            a_revoir: 'Their review date has passed. These are the first to go.',
            erreurs: 'Missed at the last encounter. They come back tomorrow.',
            appris: 'Answered right five times in a row. They hold on their own.',
          },
          empty: {
            a_revoir: 'Nothing to review today.',
            erreurs: 'No word got wrong. Nothing to catch up on.',
            appris: 'No word learned yet. It takes five successful recalls.',
          },
          quiz: (n) => `Review ${n} word${n > 1 ? 's' : ''}`,
          tropPeu: (n) => `At least ${n} words are needed to start a series.`,
          more: (n) => `and ${n} more`,
          intro: 'Your words, sorted by what memory says about them.',
        },
        textesOff: 'End-of-series texts are hidden.',
        textesOn: 'Show them again',
        title: 'Your progress',
        intro: 'Keep your progress across all your devices and sites.',
        tabCreate: 'Create account',
        tabLogin: 'Log in',
        handle: 'Username',
        handlePlaceholder: 'a username',
        passphrase: 'Passphrase',
        passphrasePlaceholder: 'your passphrase',
        passphraseHint: 'At least 8 characters. Write it down: with no email, it cannot be reset.',
        createBtn: 'Create account',
        loginBtn: 'Log in',
        logoutBtn: 'Log out',
        loggedInAs: (h) => `account: ${h}`,
        deleteAccount: 'Delete account',
        deleteConfirm: 'Confirm deletion',
        inviteLine: 'Your progress lives only in this browser.',
        inviteCta: 'Keep it elsewhere',
        mergePrompt: 'Unlinked progress exists on this device. Merge it into this account?',
        mergeYes: 'Merge',
        mergeNo: 'Skip',
        close: 'Close',
        errors: {
          handle_invalid: 'Invalid username (3 to 32 characters: letters, digits, . _ -).',
          passphrase_weak: 'Passphrase too weak (at least 8 characters).',
          handle_taken: 'This username is already taken.',
          already_claimed: 'This device already has an account.',
          invalid_credentials: 'Incorrect username or passphrase.',
          rate_limited: 'Too many attempts. Try again in a few minutes.',
          generic: 'Something went wrong. Please try again.',
        },
      },
    },
  },

  de: {
    apiLang: 'de',
    wordField: 'deutsch',
    exampleRuField: 'example_ru_de',
    exampleLangField: 'example_de',
    audioEx: 'ex_de',
    noneLabel: 'Keine dieser Antworten',
    ui: {
      frequencyLabels: ['500 Wörter', '1.000 Wörter', '2.000 Wörter', '4.000 Wörter', '6.000 Wörter'],
      titlePrefix: 'Lerne die',
      titleSuffix: 'häufigsten russischen Wörter',
      home: 'Startseite',
      wordList: 'Wörterbuch',
      cursiveToggle: 'Russisch in Schreibschrift / Druckschrift anzeigen',
      progressSaved: 'Meinen Fortschritt speichern',
      couverture: (v) => `${String(v).replace('.', ',')} % der Wörter eines russischen Textes`,
      cancel: 'Abbrechen',
      feedback: 'Feedback / Vorschläge:',
      supportLine: 'Feedback, Kritik oder Unterstützung:',
      supportCard: 'Karte / Apple Pay',
      soundOn: 'Ton deaktivieren',
      soundOff: 'Ton aktivieren',
      listen: 'Anhören',
      listenAgain: 'Nochmal anhören',
      pause: 'Pause',
      resume: 'Fortsetzen',
      loading: 'Wird geladen…',
      errorPrefix: 'Fehler:',
      retry: 'Erneut versuchen',
      noWords: 'Keine Wörter verfügbar.',
      bonusQuestion: 'Welchen Satz haben Sie gehört?',
      bonus: {
        cloze:   'Ergänze den Satz',
        match:   'Ordne jedes Wort seiner Übersetzung zu',
        anagram: 'Bring die Buchstaben in die richtige Reihenfolge',
        reverse: 'Welches russische Wort passt?',
        listen:  'Was hast du gehört?',
      },
      backToRussian: '← Russisch anzeigen',
      seeTranslation: 'Übersetzung anzeigen →',
      next: 'weiter →',
      paused: 'Pausiert : ▶ drücken zum Fortfahren',
      tapForExample: 'Beispielsatz anzeigen',
      tapToSeeWord: 'Wort wieder anzeigen',
      toReview: (n) => `Zu wiederholen (${n})`,
      reviewTooltip: 'Falsch beantwortete Wörter kommen zurück, bis Sie sie zweimal richtig haben. ● = zu wiederholen · ✓ = gelernt',
      reviewLegend: '● zu wiederholen · ✓ gelernt',
      session: {
        doneTitle: 'Sitzung beendet',
        rescued: 'vor dem Vergessen bewahrt',
        continueBtn: 'Weiter',
        correct: 'richtig',
        seen: 'Wörter gesehen',
        days: (n) => (n > 1 ? 'Tage' : 'Tag'),
      },
      texte: {
        listen: 'Text anhören',
        optOutPrompt: 'Sie überspringen diese Texte jedes Mal. Sollen wir sie ausblenden?',
        optOutYes: 'Nicht mehr anzeigen',
        optOutNo: 'Weiter anzeigen',
        eyebrow: 'Bonus',
        skip: 'Überspringen',
        next: 'Zur Übersicht',
        formats: { texto: 'Nachricht', enigme: 'Rätsel', fait: 'Wusstest du',
                   annonce: 'Kleinanzeige', journal: 'Tagebuch', conte: 'Märchen',
                   dialogue: 'Dialog' },
      },
      levelTest: {
        introTitle: 'Russisch-Niveautest',
        timeCap: 'Verbleibende Antwortzeit',
        progressLbl: 'Testfortschritt',
        loadError: 'Wörter konnten nicht geladen werden.',
        chooseTranslation: 'Wähle die Übersetzung',
        chooseWord: 'Wähle das russische Wort',
        fillBlank: 'Ergänze den Satz',
        listenPick: 'Hören und Übersetzung wählen',
        listenSpell: 'Hören und Schreibweise wählen',
        readCursive: 'Handschrift: Was bedeutet dieses Wort?',
        range: (a, b) => `geschätzt zwischen ${a} und ${b} Wörtern`,
        resultTitle: 'Dein geschätztes Niveau',
        cefrName: { A1: 'Anfänger', A2: 'Grundstufe', B1: 'Mittelstufe', B2: 'Obere Mittelstufe', C1: 'Fortgeschritten' },
        wordsScale: 'der 6000 häufigsten Wörter',
        disclaimer: 'Richtwert auf Basis des Häufigkeitswortschatzes. Keine offizielle Prüfung.',
        ctaTrain: 'Auf diesem Niveau üben',
        share: 'Mein Ergebnis teilen',
        shared: '✓ Kopiert',
        shareText: (cefr, words) => `Mein Russisch-Niveau: ${cefr} (≈ ${words} Wörter). Und deins?`,
        ctaRetake: 'Test wiederholen',
        linkLabel: 'Niveautest',
        pagePath: '/mot/de/russisch-niveautest.html',
      },
      fullQuiz: 'Ganzes Quiz',
      replique: 'Wähle die natürlichste Antwort',
      srs: {
        due: 'zu wiederholen',
        soon: 'bald',
        solid: 'gefestigt',
      },
      about: 'Über diese Seite',
      aboutUrl: '/mot/de/ueber.html',
      noneCorrectLabel: (word) => `Keine (Antwort: ${word})`,
      account: {
        mots: {
          title: 'Ihre Wörter',
          tabs: { a_revoir: 'Zu wiederholen', erreurs: 'Falsch', appris: 'Gelernt' },
          hints: {
            a_revoir: 'Ihr Wiederholungstermin ist überschritten. Sie gehen zuerst verloren.',
            erreurs: 'Beim letzten Mal falsch. Sie kommen schon morgen wieder.',
            appris: 'Fünfmal hintereinander richtig. Sie halten von allein.',
          },
          empty: {
            a_revoir: 'Heute nichts zu wiederholen.',
            erreurs: 'Kein falsches Wort. Nichts nachzuholen.',
            appris: 'Noch kein Wort gelernt. Es braucht fünf gelungene Abrufe.',
          },
          quiz: (n) => `${n} ${n > 1 ? 'Wörter' : 'Wort'} wiederholen`,
          tropPeu: (n) => `Für eine Serie braucht es mindestens ${n} Wörter.`,
          more: (n) => `und ${n} weitere`,
          intro: 'Ihre Wörter, geordnet nach dem, was das Gedächtnis dazu sagt.',
        },
        textesOff: 'Die Texte am Serienende sind ausgeblendet.',
        textesOn: 'Wieder anzeigen',
        title: 'Ihr Fortschritt',
        intro: 'Behalten Sie Ihren Fortschritt auf allen Geräten und Seiten.',
        tabCreate: 'Konto erstellen',
        tabLogin: 'Anmelden',
        handle: 'Benutzername',
        handlePlaceholder: 'ein Benutzername',
        passphrase: 'Passphrase',
        passphrasePlaceholder: 'Ihre Passphrase',
        passphraseHint: 'Mindestens 8 Zeichen. Notieren Sie sie: ohne E-Mail kann sie nicht zurückgesetzt werden.',
        createBtn: 'Konto erstellen',
        loginBtn: 'Anmelden',
        logoutBtn: 'Abmelden',
        loggedInAs: (h) => `Konto: ${h}`,
        deleteAccount: 'Konto löschen',
        deleteConfirm: 'Löschen bestätigen',
        inviteLine: 'Ihr Fortschritt lebt nur in diesem Browser.',
        inviteCta: 'Woanders sichern',
        mergePrompt: 'Auf diesem Gerät gibt es nicht verknüpften Fortschritt. In dieses Konto zusammenführen?',
        mergeYes: 'Zusammenführen',
        mergeNo: 'Überspringen',
        close: 'Schließen',
        errors: {
          handle_invalid: 'Ungültiger Benutzername (3 bis 32 Zeichen: Buchstaben, Ziffern, . _ -).',
          passphrase_weak: 'Passphrase zu schwach (mindestens 8 Zeichen).',
          handle_taken: 'Dieser Benutzername ist bereits vergeben.',
          already_claimed: 'Dieses Gerät hat bereits ein Konto.',
          invalid_credentials: 'Benutzername oder Passphrase falsch.',
          rate_limited: 'Zu viele Versuche. Versuchen Sie es in einigen Minuten erneut.',
          generic: 'Ein Fehler ist aufgetreten. Bitte erneut versuchen.',
        },
      },
    },
  },

  es: {
    apiLang: 'es',
    wordField: 'espagnol',
    exampleRuField: 'example_ru_es',
    exampleLangField: 'example_es',
    audioEx: 'ex_es',
    noneLabel: 'Ninguna de estas respuestas',
    ui: {
      frequencyLabels: ['500 palabras', '1.000 palabras', '2.000 palabras', '4.000 palabras', '6.000 palabras'],
      titlePrefix: 'Aprende las',
      titleSuffix: 'palabras rusas más frecuentes',
      home: 'Inicio',
      wordList: 'Diccionario',
      cursiveToggle: 'Mostrar el ruso en cursiva / letra de imprenta',
      progressSaved: 'Guardar mi progreso',
      couverture: (v) => `${String(v).replace('.', ',')} % de las palabras de un texto ruso`,
      cancel: 'cancelar',
      feedback: 'Comentarios / sugerencias:',
      supportLine: 'Comentarios, críticas o apoyo:',
      supportCard: 'Tarjeta / Apple Pay',
      soundOn: 'Desactivar sonido',
      soundOff: 'Activar sonido',
      listen: 'Escuchar',
      listenAgain: 'Escuchar de nuevo',
      pause: 'Pausa',
      resume: 'Reanudar',
      loading: 'Cargando…',
      errorPrefix: 'Error:',
      retry: 'Reintentar',
      noWords: 'No hay palabras disponibles.',
      bonusQuestion: '¿Qué frase has escuchado?',
      bonus: {
        cloze:   'Completa la frase',
        match:   'Relaciona cada palabra con su traducción',
        anagram: 'Ordena las letras',
        reverse: '¿Qué palabra rusa corresponde?',
        listen:  '¿Qué has oído?',
      },
      backToRussian: '← ver en ruso',
      seeTranslation: 'ver traducción →',
      next: 'siguiente →',
      paused: 'En pausa : pulsa ▶ para continuar',
      tapForExample: 'ver una frase de ejemplo',
      tapToSeeWord: 'ver la palabra de nuevo',
      toReview: (n) => `A repasar (${n})`,
      reviewTooltip: 'Las palabras falladas vuelven hasta que las aciertes dos veces seguidas. ● = a repasar · ✓ = dominada',
      reviewLegend: '● a repasar · ✓ dominada',
      session: {
        doneTitle: 'Sesión terminada',
        rescued: 'salvadas del olvido',
        continueBtn: 'Continuar',
        correct: 'aciertos',
        seen: 'palabras vistas',
        days: (n) => (n > 1 ? 'días' : 'día'),
      },
      texte: {
        listen: 'Escuchar el texto',
        optOutPrompt: 'Saltas estos textos cada vez. ¿Dejamos de mostrarlos?',
        optOutYes: 'Dejar de mostrarlos',
        optOutNo: 'Seguir viéndolos',
        eyebrow: 'Bonus',
        skip: 'Saltar',
        next: 'Ver el resumen',
        formats: { texto: 'Mensaje', enigme: 'Adivinanza', fait: 'Sabías que',
                   annonce: 'Anuncio', journal: 'Diario', conte: 'Cuento',
                   dialogue: 'Diálogo' },
      },
      levelTest: {
        introTitle: 'Test de nivel de ruso',
        timeCap: 'Tiempo restante para responder',
        progressLbl: 'Progreso del test',
        loadError: 'no se pudieron cargar las palabras.',
        chooseTranslation: 'Elige la traducción',
        chooseWord: 'Elige la palabra rusa',
        fillBlank: 'Completa la frase',
        listenPick: 'Escucha y elige la traducción',
        listenSpell: 'Escucha y elige la ortografía',
        readCursive: 'Escritura a mano: ¿qué significa esta palabra?',
        range: (a, b) => `estimación entre ${a} y ${b} palabras`,
        resultTitle: 'Tu nivel estimado',
        cefrName: { A1: 'Principiante', A2: 'Elemental', B1: 'Intermedio', B2: 'Intermedio alto', C1: 'Avanzado' },
        wordsScale: 'de las 6000 palabras más frecuentes',
        disclaimer: 'Estimación indicativa basada en el vocabulario de frecuencia. No es un examen oficial.',
        ctaTrain: 'Practicar a este nivel',
        share: 'Compartir mi resultado',
        shared: '✓ Copiado',
        shareText: (cefr, words) => `Mi nivel de ruso: ${cefr} (≈ ${words} palabras). ¿Y el tuyo?`,
        ctaRetake: 'Repetir el test',
        linkLabel: 'Test de nivel',
        pagePath: '/mot/es/test-nivel-ruso.html',
      },
      fullQuiz: 'Quiz completo',
      replique: 'Elige la respuesta más natural',
      srs: {
        due: 'por repasar',
        soon: 'pronto',
        solid: 'consolidadas',
      },
      about: 'Acerca de',
      aboutUrl: '/mot/es/acerca.html',
      noneCorrectLabel: (word) => `Ninguna (respuesta: ${word})`,
      account: {
        mots: {
          title: 'Tus palabras',
          tabs: { a_revoir: 'Por repasar', erreurs: 'Falladas', appris: 'Aprendidas' },
          hints: {
            a_revoir: 'Su fecha de repaso ya pasó. Son las primeras en irse.',
            erreurs: 'Falladas en el último encuentro. Vuelven mañana.',
            appris: 'Acertadas cinco veces seguidas. Se sostienen solas.',
          },
          empty: {
            a_revoir: 'Nada que repasar hoy.',
            erreurs: 'Ninguna palabra fallada. Nada que recuperar.',
            appris: 'Aún ninguna palabra aprendida. Hacen falta cinco aciertos.',
          },
          quiz: (n) => `Repasar ${n} palabra${n > 1 ? 's' : ''}`,
          tropPeu: (n) => `Hacen falta al menos ${n} palabras para lanzar una serie.`,
          more: (n) => `y ${n} más`,
          intro: 'Tus palabras, ordenadas según lo que dice la memoria.',
        },
        textesOff: 'Los textos de fin de serie están ocultos.',
        textesOn: 'Volver a mostrarlos',
        title: 'Tu progreso',
        intro: 'Conserva tu progreso en todos tus dispositivos y sitios.',
        tabCreate: 'Crear cuenta',
        tabLogin: 'Iniciar sesión',
        handle: 'Usuario',
        handlePlaceholder: 'un usuario',
        passphrase: 'Frase secreta',
        passphrasePlaceholder: 'tu frase secreta',
        passphraseHint: 'Al menos 8 caracteres. Anótala: sin email, no se puede restablecer.',
        createBtn: 'Crear cuenta',
        loginBtn: 'Iniciar sesión',
        logoutBtn: 'Cerrar sesión',
        loggedInAs: (h) => `cuenta: ${h}`,
        deleteAccount: 'Eliminar la cuenta',
        deleteConfirm: 'Confirmar eliminación',
        inviteLine: 'Tu progreso solo vive en este navegador.',
        inviteCta: 'Guardarlo en otro sitio',
        mergePrompt: 'Hay progreso no vinculado en este dispositivo. ¿Fusionarlo con esta cuenta?',
        mergeYes: 'Fusionar',
        mergeNo: 'Omitir',
        close: 'Cerrar',
        errors: {
          handle_invalid: 'Usuario no válido (3 a 32 caracteres: letras, números, . _ -).',
          passphrase_weak: 'Frase secreta demasiado débil (al menos 8 caracteres).',
          handle_taken: 'Este usuario ya está en uso.',
          already_claimed: 'Este dispositivo ya tiene una cuenta.',
          invalid_credentials: 'Usuario o frase secreta incorrectos.',
          rate_limited: 'Demasiados intentos. Inténtalo de nuevo en unos minutos.',
          generic: 'Ha ocurrido un error. Inténtalo de nuevo.',
        },
      },
    },
  },

  it: {
    apiLang: 'it',
    wordField: 'italiano',
    exampleRuField: 'example_ru_it',
    exampleLangField: 'example_it',
    audioEx: 'ex_it',
    noneLabel: 'Nessuna di queste risposte',
    ui: {
      frequencyLabels: ['500 parole', '1.000 parole', '2.000 parole', '4.000 parole', '6.000 parole'],
      titlePrefix: 'Impara le',
      titleSuffix: 'parole russe più frequenti',
      home: 'Home',
      wordList: 'Dizionario',
      cursiveToggle: 'Mostra il russo in corsivo / stampatello',
      progressSaved: 'Salva i miei progressi',
      couverture: (v) => `${String(v).replace('.', ',')} % delle parole di un testo russo`,
      cancel: 'annulla',
      feedback: 'Feedback / suggerimenti:',
      supportLine: 'Feedback, critiche o supporto:',
      supportCard: 'Carta / Apple Pay',
      soundOn: 'Disattiva audio',
      soundOff: 'Attiva audio',
      listen: 'Ascolta',
      listenAgain: 'Ascolta ancora',
      pause: 'Pausa',
      resume: 'Riprendi',
      loading: 'Caricamento…',
      errorPrefix: 'Errore:',
      retry: 'Riprova',
      noWords: 'Nessuna parola disponibile.',
      bonusQuestion: 'Quale frase hai sentito?',
      bonus: {
        cloze:   'Completa la frase',
        match:   'Abbina ogni parola alla sua traduzione',
        anagram: 'Rimetti le lettere in ordine',
        reverse: 'Quale parola russa corrisponde?',
        listen:  'Che cosa hai sentito?',
      },
      backToRussian: '← vedi in russo',
      seeTranslation: 'vedi traduzione →',
      next: 'avanti →',
      paused: 'In pausa : premi ▶ per continuare',
      tapForExample: 'vedi una frase di esempio',
      tapToSeeWord: 'vedi la parola di nuovo',
      toReview: (n) => `Da rivedere (${n})`,
      reviewTooltip: 'Le parole sbagliate tornano finché non le indovini due volte di fila. ● = da rivedere · ✓ = appresa',
      reviewLegend: '● da rivedere · ✓ appresa',
      session: {
        doneTitle: 'Sessione completata',
        rescued: "salvate dall'oblio",
        continueBtn: 'Continua',
        correct: 'corrette',
        seen: 'parole viste',
        days: (n) => (n > 1 ? 'giorni' : 'giorno'),
      },
      texte: {
        listen: 'Ascolta il testo',
        optOutPrompt: 'Salti questi testi ogni volta. Smettiamo di mostrarli?',
        optOutYes: 'Non mostrarli più',
        optOutNo: 'Continuare a vederli',
        eyebrow: 'Bonus',
        skip: 'Salta',
        next: 'Vedi il riepilogo',
        formats: { texto: 'Messaggio', enigme: 'Indovinello', fait: 'Lo sapevi',
                   annonce: 'Annuncio', journal: 'Diario', conte: 'Fiaba',
                   dialogue: 'Dialogo' },
      },
      levelTest: {
        introTitle: 'Test di livello di russo',
        timeCap: 'Tempo rimasto per rispondere',
        progressLbl: 'Avanzamento del test',
        loadError: 'impossibile caricare le parole.',
        chooseTranslation: 'Scegli la traduzione',
        chooseWord: 'Scegli la parola russa',
        fillBlank: 'Completa la frase',
        listenPick: 'Ascolta e scegli la traduzione',
        listenSpell: 'Ascolta e scegli l\u2019ortografia',
        readCursive: 'Scrittura a mano: che cosa significa questa parola?',
        range: (a, b) => `stima tra ${a} e ${b} parole`,
        resultTitle: 'Il tuo livello stimato',
        cefrName: { A1: 'Principiante', A2: 'Elementare', B1: 'Intermedio', B2: 'Intermedio superiore', C1: 'Avanzato' },
        wordsScale: 'delle 6000 parole più frequenti',
        disclaimer: 'Stima indicativa basata sul vocabolario di frequenza. Non è un esame ufficiale.',
        ctaTrain: 'Allenarmi a questo livello',
        share: 'Condividi il risultato',
        shared: '✓ Copiato',
        shareText: (cefr, words) => `Il mio livello di russo: ${cefr} (≈ ${words} parole). E il tuo?`,
        ctaRetake: 'Rifare il test',
        linkLabel: 'Test di livello',
        pagePath: '/mot/it/test-livello-russo.html',
      },
      fullQuiz: 'Quiz completo',
      replique: 'Scegli la risposta più naturale',
      srs: {
        due: 'da rivedere',
        soon: 'presto',
        solid: 'consolidate',
      },
      about: 'Informazioni',
      aboutUrl: '/mot/it/info.html',
      noneCorrectLabel: (word) => `Nessuna (risposta: ${word})`,
      account: {
        mots: {
          title: 'Le tue parole',
          tabs: { a_revoir: 'Da ripassare', erreurs: 'Sbagliate', appris: 'Imparate' },
          hints: {
            a_revoir: 'La data di ripasso è passata. Sono le prime ad andarsene.',
            erreurs: 'Sbagliate all\u2019ultimo incontro. Tornano già domani.',
            appris: 'Indovinate cinque volte di fila. Si reggono da sole.',
          },
          empty: {
            a_revoir: 'Niente da ripassare oggi.',
            erreurs: 'Nessuna parola sbagliata. Niente da recuperare.',
            appris: 'Ancora nessuna parola imparata. Servono cinque richiami riusciti.',
          },
          quiz: (n) => `Ripassare ${n} ${n > 1 ? 'parole' : 'parola'}`,
          tropPeu: (n) => `Servono almeno ${n} parole per lanciare una serie.`,
          more: (n) => `e altre ${n}`,
          intro: 'Le tue parole, ordinate secondo quel che dice la memoria.',
        },
        textesOff: 'I testi di fine serie sono nascosti.',
        textesOn: 'Mostrarli di nuovo',
        title: 'I tuoi progressi',
        intro: 'Ritrova i tuoi progressi su tutti i dispositivi e i siti.',
        tabCreate: 'Crea un account',
        tabLogin: 'Accedi',
        handle: 'Nome utente',
        handlePlaceholder: 'un nome utente',
        passphrase: 'Frase segreta',
        passphrasePlaceholder: 'la tua frase segreta',
        passphraseHint: 'Almeno 8 caratteri. Annotala: senza email non può essere reimpostata.',
        createBtn: 'Crea account',
        loginBtn: 'Accedi',
        logoutBtn: 'Esci',
        loggedInAs: (h) => `account: ${h}`,
        deleteAccount: "Elimina l'account",
        deleteConfirm: 'Conferma eliminazione',
        inviteLine: 'I tuoi progressi vivono solo in questo browser.',
        inviteCta: 'Conservarli altrove',
        mergePrompt: 'Su questo dispositivo esistono progressi non collegati. Unirli a questo account?',
        mergeYes: 'Unisci',
        mergeNo: 'Ignora',
        close: 'Chiudi',
        errors: {
          handle_invalid: 'Nome utente non valido (da 3 a 32 caratteri: lettere, numeri, . _ -).',
          passphrase_weak: 'Frase segreta troppo debole (almeno 8 caratteri).',
          handle_taken: 'Questo nome utente è già in uso.',
          already_claimed: 'Questo dispositivo ha già un account.',
          invalid_credentials: 'Nome utente o frase segreta errati.',
          rate_limited: 'Troppi tentativi. Riprova tra qualche minuto.',
          generic: 'Si è verificato un errore. Riprova.',
        },
      },
    },
  },
};

export const ALL_SITES = [
  { code: 'fr', label: 'FR', url: 'https://motsrusse.fr' },
  { code: 'en', label: 'EN', url: 'https://myrussianwords.com' },
  { code: 'de', label: 'DE', url: 'https://meinrussisch.de' },
  { code: 'es', label: 'ES', url: 'https://palabrasrusas.es' },
  { code: 'it', label: 'IT', url: 'https://parolerusse.it' },
];

export const LangContext = createContext(LANGS.fr);

export function useLang() {
  return useContext(LangContext);
}

export function detectLang() {
  const host = window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');
  const code = DOMAIN_MAP[host] ?? 'fr';
  return LANGS[code] ?? LANGS.fr;
}
